import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import Logo from "../media/Logo.png"
import './burger.scss'

function NavBarBurger({ cartCount }) {

  const [active, setActive] = useState(false);

    const toggle = () => {
    setActive(!active);
  };

  return (
    <div className='menu_burger'>
      <div className='menu_burger-nav'>
          <img src={Logo} alt="logo" />
          <figure className={`js-burger-toggle-colapse-spin ${active ? 'active' : ''}`} onClick={toggle}>
            <div class="inner">
            <span></span>
            <span></span>
            <span></span>
            </div>
        </figure>
      </div>
      <div className={`sidebar ${active ? 'active' : ''}`}>
        <nav>
          <NavLink to="/" end onClick={toggle}>Strona główna</NavLink>
          <NavLink to="/pozostale_uslugi" onClick={toggle}>Pozostałe usługi</NavLink>
          <NavLink to="/motocykle" onClick={toggle}>Motocykle</NavLink>
          <NavLink to="/serwis" onClick={toggle}>Serwis</NavLink>
          <NavLink to="/cennik" onClick={toggle}>Cennik</NavLink>
          <NavLink to="/o-firmie" onClick={toggle}>O Firmie</NavLink>
          <NavLink to="/kontakt" onClick={toggle}>Kontakt</NavLink>
            <a
              href="https://allegro.pl/uzytkownik/promotoserwis"
              target="_blank"
              rel="noopener noreferrer"
              className="allegro-btn"
            >
              Sklep Allegro
            </a>
        </nav>
      </div>
    </div>
  );
}

export default NavBarBurger;